import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { WaiversPoliciesApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

interface UseWaiversGetProps {
  userId: number;
}

export const useWaiversGet = ({ userId }: UseWaiversGetProps) => {
  const accessToken = useAccessToken();

  const { data, isLoading } = useQuery({
    queryKey: [QueryKeys.Waivers, "byUserId", userId],
    queryFn: () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(WaiversPoliciesApi, accessToken);
      return service.getPolicyById({
        id: userId,
      });
    },
    enabled: !!accessToken && !!userId,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isLoading,
  };
};
